module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Italic-589b8eb913c484300833b62038f43ec2.woff2";